export default __webpack_public_path__ + "static/media/potion4.b73646fd.png";